import { Component } from "react";
import styles from "./Leg.module.scss";
import moment from "moment";
import {
  Walk,
  Ferry,
  CableCar,
  Rail,
  Bus,
  Tram,
  Underground,
  Drive,
  Park,
  Cycle,
  CycleDock,
  Destination,
  Plane,
  EvStation,
} from "../../utils/index";
import axios from "axios";
import { ThemeContext } from "../../Context/ThemeContext";
import { Context as LanguageContext } from "../../Context/LanguageContext";

import { FormattedMessage, injectIntl } from "react-intl";
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/it";

const dots = ["", ".", "..", "...", "...."];
const loadingInterval = Math.round(2000 / (dots.length * 2));
let timer;
class Leg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pressed: false,
      timeDifference: 0,
    };
  }

  static contextType = LanguageContext;
  prevLang = null;

  componentDidUpdate() {
    if (this.context.lang !== this.prevLang) {
      moment.locale(this.context.lang);
      this.prevLang = this.context.lang;
      this.setState({}); // Force re-render to account for locale change.
    }
  }

  dwellTimeUpdated = (event) => {
    var newDate = new Date(
      new Date(this.props.leg.arrivalTime).toDateString() +
        " " +
        event.target.value
    );
    var timeDifferenceTemp = 0;

    if (typeof this.props.leg.dwellTimeActive === "undefined") {
      timeDifferenceTemp =
        newDate.getTime() - new Date(this.props.leg.arrivalTime).getTime();
    } else {
      timeDifferenceTemp =
        newDate.getTime() - new Date(this.props.leg.arrivalTime).getTime();
    }

    this.setState({ timeDifference: timeDifferenceTemp });
  };
  toggleClass = (event) => {
    this.setState({ pressed: !this.state.pressed });
    if (this.state.pressed) {
      this.props.onUpdateTimeClicked(
        this.props.legIndex,
        this.state.timeDifference
      );
    }
  };

  handleJourneyLegClicked = (e) => {
    e.stopPropagation();
    const leg = this.props.leg;
    this.props.onJourneyLegClicked(
      leg,
      this.props.leg.boundingBox,
      this.props.legIndex,
      false
    );
  };

  handleRandom = () => {
    this.toggleSelection();
  };

  toggleSelection = () => {
    this.props.toggleSelection();
  };

  showInfoPopup = (info) => {
    console.log("1");
    this.props.showInfoPopup(info);
  };

  toggleRequestAssistance = (travelforecastId) => {
    this.props.toggleRequestAssistance(travelforecastId);
  };

  render() {
    var {
      departureTime,
      estimatedDepartureTime,
      arrivalTime,
      estimatedArrivalTime,
      distance,
      operatorName,
      duration,
      endLocation,
      startLocation,
      mode,
      routeCode,
      dwellTimeActive,
      timeDifferenceDeparture,
      timeDifferenceArrival,
      intermediateStops,
    } = this.props.leg;
    const { intl } = this.props;

    var fareAmount;
    if (this.props.fareDetails) {
      fareAmount =
        this.props.fareDetails.currency === "GBP"
          ? "£" + this.props.fareDetails.price.toFixed(2)
          : this.props.fareDetails.price.toFixed(2) +
            " " +
            this.props.fareDetails.currency;
    }

    if (dwellTimeActive) {
      departureTime = new Date(
        new Date(departureTime).getTime() + timeDifferenceDeparture
      );
      arrivalTime = new Date(
        new Date(arrivalTime).getTime() + timeDifferenceArrival
      );
    }

    const legIcon = {
      Walk: <Walk className={styles["Walk"]} />,
      Rail: <Rail className={styles["Rail"]} />,
      Bus: <Bus className={styles["Bus"]} />,
      ReplacementBus: <Bus className={styles["Bus"]} />,
      Ferry: <Ferry className={styles["Ferry"]} />,
      CableCar: <CableCar className={styles["CableCar"]} />,
      Cycle: <Cycle className={styles["Cycle"]} />,
      CycleDock: <CycleDock className={styles["Cycle"]} />,
      CycleStreetsQuietest: <Cycle className={styles["Cycle"]} />,
      CycleStreetsFastest: <Cycle className={styles["Cycle"]} />,
      CycleStreetsBalanced: <Cycle className={styles["Cycle"]} />,
      CycleStreetsDefault: <Cycle className={styles["Cycle"]} />,
      Tram: <Tram className={styles["Tram"]} />,
      Metro: <Tram className={styles["Metro"]} />,
      Coach: <Bus className={styles["Coach"]} />,
      Underground: <Underground className={styles["Underground"]} />,
      Drive: <Drive className={styles["Drive"]} />,
      ElectricVehicle: <Drive className={styles["Drive"]} />,
      Park: <Park className={styles["Park"]} />,
      PlatformChange: <Walk className={styles["Walk"]} />,
      EvStation: <EvStation className={styles["EvStation"]} />,
      Flight: <Plane className={styles["Plane"]} />,
      Destination: <Destination className={styles["Destination"]} />,
    }[mode];

    return (
      <ThemeContext.Consumer>
        {(theme) => (
          <li
            className={
              this.props.className === "active"
                ? styles["legActive"]
                : styles["leg"]
            }
            style={{ "--theme-color": theme.theme.primaryColour }}
            onClick={this.handleJourneyLegClicked}
            tabIndex="0"
            role="listitem"
            aria-label={`${moment
              .parseZone(departureTime)
              .format("H:mm")} ${mode} from ${startLocation.description} to ${
              endLocation.description
            }${
              routeCode
                ? `, ${
                    mode === "Bus"
                      ? "Bus"
                      : mode === "Underground"
                      ? "Line"
                      : "Route"
                  } ${routeCode}`
                : ""
            }${
              distance > 0
                ? `, Distance ${distance.toFixed(2)} ${
                    theme.isKilometres ? "kilometres" : "miles"
                  }`
                : ""
            }${operatorName ? `, operated by ${operatorName}` : ""}, Duration ${
              Math.floor(duration / 60) > 0
                ? `${Math.floor(duration / 60)} hours `
                : ""
            }${duration % 60 > 0 ? `${duration % 60} minutes` : ""}, Arrival ${
              mode !== "Destination"
                ? moment.parseZone(arrivalTime).format("H:mm")
                : ""
            }${
              intermediateStops && intermediateStops.length > 0
                ? `, ${intermediateStops.length} intermediate ${
                    intermediateStops.length === 1 ? "stop" : "stops"
                  }`
                : ""
            }${this.props.hasDirections ? ", directions available" : ""}${
              fareAmount ? `, fare ${fareAmount}` : ""
            }`}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();

                // Check if focus is on a button inside the leg
                const focusedElement = document.activeElement;
                if (focusedElement && focusedElement.tagName === "BUTTON") {
                  // If focused on a button, trigger its click instead
                  focusedElement.click();
                } else {
                  // Otherwise, trigger the leg click
                  this.handleJourneyLegClicked(e);
                }
              }
            }}
          >
            <div className={styles["leg-sub"]}>
              <div className={styles["leg-icon-outer-container"]}>
                <div className={styles["leg-icon-inner-container"]}>
                  <div data-cy={"legs"} className={styles["leg-icon"]}>
                    {legIcon}
                  </div>
                </div>
              </div>
              <div className={styles["leg-title-outer-container"]}>
                <div className={styles["leg-title-inner-container"]}>
                  <div className={styles["leg-title"]}>
                    <div className={styles["leg-subtitle-container"]}>
                      <span className={styles["leg-subtitle"]}>
                        {moment.parseZone(departureTime).format("H:mm") + " "}
                        {this.props.showExtendedDate || mode === "Flight"
                          ? moment
                              .parseZone(departureTime)
                              .format(
                                intl.formatMessage({ id: "dateFormat" })
                              ) + " "
                          : ""}

                        {estimatedDepartureTime !== undefined && (
                          <span className={styles["leg-subtitle-estimated"]}>
                            Est.
                            {" " +
                              moment
                                .parseZone(estimatedDepartureTime)
                                .format("H:mm")}
                          </span>
                        )}
                      </span>
                    </div>
                    <div className={styles["leg-content"]}>
                      {mode === "Destination" &&
                      this.props.legIndex !== this.props.legLength - 1 ? (
                        <div>
                          <span>{endLocation.description}</span>
                          <br />
                          {this.props?.allowEditTime ? (
                            <button
                              className={styles["a"]}
                              onClick={this.toggleClass}
                              aria-label={
                                this.state.pressed
                                  ? "Update departure time"
                                  : "Edit departure time"
                              }
                              tabIndex="0"
                            >
                              {this.state.pressed
                                ? intl.formatMessage({ id: "updateDeparture" })
                                : intl.formatMessage({ id: "editDeparture" })}
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : mode === "Destination" &&
                        this.props.legIndex === this.props.legLength - 1 ? (
                        endLocation.description
                      ) : mode === "PlatformChange" ? (
                        intl.formatMessage({ id: "changePlatform" }) +
                        endLocation.description
                      ) : mode !== "EvStation" ? (
                        mode === "CycleDock" ? (
                          intl.formatMessage({ id: "collectAt" }) +
                          startLocation.description +
                          intl.formatMessage({ id: "dockAt" }) +
                          endLocation.description
                        ) : (
                          startLocation.description +
                          " " +
                          intl.formatMessage({ id: "to" }).toLowerCase() +
                          " " +
                          endLocation.description
                        )
                      ) : (
                        intl.formatMessage({ id: "chargeAt" }) +
                        startLocation.description
                      )}
                    </div>
                    {routeCode && mode === "Underground"
                      ? ` (" ${routeCode} ${intl.formatMessage({
                          id: "line",
                        })}) `
                      : routeCode && mode === "Bus"
                      ? ` (${intl.formatMessage({ id: "bus" })} ${routeCode}) `
                      : routeCode
                      ? ` (${routeCode}) `
                      : ""}
                    {distance <= 0 ? (
                      <div className={styles["leg-subtitle-container"]}>
                        <span className={styles["leg-subtitle"]}>
                          {operatorName}
                        </span>
                      </div>
                    ) : (
                      <div className={styles["leg-subtitle-container"]}>
                        <span className={styles["leg-subtitle"]}>
                          {distance ? distance.toFixed(2) : ""}
                          {distance ? (
                            theme.isKilometres ? (
                              <>
                                {" "}
                                <FormattedMessage id="kilometres" />{" "}
                              </>
                            ) : (
                              <>
                                {" "}
                                <FormattedMessage id="miles" />{" "}
                              </>
                            )
                          ) : (
                            ""
                          )}
                          {this.props.hasIntermediateStops ? (
                            this.props.isIntermediateStopsVisible ? (
                              <button
                                className={styles["show-directions-button"]}
                                onClick={() => {
                                  this.props.toggleIntermediateStopsModal();
                                }}
                                style={{ color: theme.theme.primaryColour }}
                                aria-label={`Show ${
                                  intermediateStops?.length || 0
                                } intermediate stops`}
                                tabIndex="0"
                              >
                                {intermediateStops &&
                                intermediateStops.length > 0
                                  ? `${intl.formatMessage({ id: "show" })} ${
                                      intermediateStops.length
                                    } ${
                                      intermediateStops.length === 1
                                        ? intl.formatMessage({ id: "stop" })
                                        : intl.formatMessage({ id: "stops" })
                                    }`
                                  : ""}
                              </button>
                            ) : intermediateStops &&
                              intermediateStops.length > 0 ? (
                              ` ${intermediateStops.length} ${
                                intermediateStops.length === 1
                                  ? intl.formatMessage({ id: "stop" })
                                  : intl.formatMessage({ id: "stops" })
                              }`
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    )}
                    <div className={styles["leg-subtitle-container"]}>
                      <span className={styles["leg-subtitle"]}>
                        {mode !== "Destination" ? (
                          moment.parseZone(arrivalTime).format("H:mm") + " "
                        ) : !this.state.pressed &&
                          mode === "Destination" &&
                          this.props.legIndex !== this.props.legLength - 1 ? (
                          moment.parseZone(arrivalTime).format("H:mm") + " "
                        ) : this.state.pressed &&
                          mode === "Destination" &&
                          this.props.legIndex !== this.props.legLength - 1 ? (
                          <input
                            className={styles["input"]}
                            type="time"
                            onChange={this.dwellTimeUpdated}
                            defaultValue={moment
                              .parseZone(arrivalTime)
                              .format("H:mm")}
                          />
                        ) : (
                          ""
                        )}
                        {mode === "Flight"
                          ? moment
                              .parseZone(arrivalTime)
                              .format(
                                intl.formatMessage({ id: "dateFormat" })
                              ) + " "
                          : ""}

                        {estimatedArrivalTime !== undefined && (
                          <span className={styles["leg-subtitle-estimated"]}>
                            Est.
                            {" " +
                              moment
                                .parseZone(estimatedArrivalTime)
                                .format("H:mm")}
                          </span>
                        )}
                      </span>
                      {this.props.hasDirections ? (
                        <button
                          className={styles["show-directions-button"]}
                          onClick={() => {
                            this.props.toggleDirectionsModal();
                          }}
                          style={{ color: theme.theme.primaryColour }}
                          aria-label="Show turn-by-turn directions for this leg"
                          tabIndex="0"
                        >
                          <FormattedMessage id="showDirections" />
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles["leg-detail-outer-container"]}>
                <div className={styles["leg-detail-inner-container"]}>
                  <div className={styles["leg-detail"]}>
                    {Math.floor(duration / 60) === 0
                      ? ""
                      : Math.floor(duration / 60) +
                        " " +
                        intl.formatMessage({ id: "hr" })}{" "}
                    {duration % 60 === 0
                      ? ""
                      : (duration % 60) +
                        " " +
                        intl.formatMessage({ id: "min" })}
                  </div>
                  {fareAmount &&
                  !theme?.hideClientElements?.includes("hideFares") ? (
                    <div
                      style={{ paddingTop: "35px" }}
                      className={styles["leg-detail"]}
                    >
                      {fareAmount}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </li>
        )}
      </ThemeContext.Consumer>
    );
  }
}

export default injectIntl(Leg);
